import { StyleSheet, Text, View, ScrollView, SafeAreaView } from "react-native";
import React, { useState } from "react";
import InputText from "../../../../components/InputText";
import { Button, useTheme } from "react-native-paper";
import { showMessage } from "react-native-flash-message";
import useApi from "../../../../hooks/useAPI";
import { RecreatePasswordScreenProps } from "../AuthStack";
import { useForm, Controller } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import recreatePasswordSchema from "../../../../schemas/recreatePasswordSchema";

type inputsData = {
	password: string;
	confirmPassword: string;
};

const RecreatePasswordScreen = ({
	route,
	navigation,
}: RecreatePasswordScreenProps) => {
	const [loading, setLoading] = useState(false);
	const api = useApi();
	const { colors } = useTheme();
	const { email, otp } = route.params;

	const {
		control,
		handleSubmit,
		formState: { errors },
	} = useForm<inputsData>({
		resolver: joiResolver(recreatePasswordSchema),
	});

	const onSubmit = async (dataOfInputs: inputsData) => {
		setLoading(true);
		try {
			await api.redefinePassword.resetPassword(
				dataOfInputs.password,
				email,
				otp
			);
			showMessage({
				type: "success",
				message: "Redefinição de senha bem-sucedida.",
			});

			navigation.navigate("Login");
		} catch (e: any) {
			showMessage({ type: "danger", message: "Redefinição de senha falhou." });
		} finally {
			setLoading(false);
		}
	};

	return (
		<SafeAreaView style={styles.root}>
			<ScrollView>
				<Text style={styles.header}>Definir uma nova senha</Text>
				<Text style={styles.text}>
					Agora, crie uma nova senha com no mínimo seis (6) caracteres que
					contenha letras e números.
				</Text>
				<View style={{ paddingHorizontal: 24 }}>
					<Controller
						control={control}
						rules={{
							required: true,
						}}
						render={({ field: { onChange, onBlur, value } }) => (
							<InputText
								placeholder="Digite uma senha"
								secureTextEntry={true}
								style={[
									styles.inputs,
									{
										borderColor: errors.password
											? colors.error
											: colors.inputBackgroundColor,
									},
								]}
								onBlur={onBlur}
								onChange={onChange}
								value={value}
								selectionColor={colors.primary}
								textColor={errors.password ? colors.error : colors.text}
								placeholderTextColor={
									errors.password ? colors.error : colors.text
								}
								disabled={loading}
							/>
						)}
						name="password"
					/>
					<Controller
						control={control}
						rules={{
							required: true,
						}}
						render={({ field: { onChange, onBlur, value } }) => (
							<InputText
								placeholder="Digite novamente sua senha"
								secureTextEntry={true}
								style={[
									styles.inputs,
									{
										marginTop: 8,
										borderColor: errors.confirmPassword
											? colors.error
											: colors.inputBackgroundColor,
									},
								]}
								onBlur={onBlur}
								onChange={onChange}
								value={value}
								selectionColor={colors.primary}
								textColor={errors.confirmPassword ? colors.error : colors.text}
								placeholderTextColor={
									errors.confirmPassword ? colors.error : colors.text
								}
								disabled={loading}
							/>
						)}
						name="confirmPassword"
					/>
					<Button
						style={styles.btn}
						labelStyle={styles.btnText}
						mode="contained"
						onPress={handleSubmit(onSubmit)}
						disabled={loading}
					>
						Confirmar
					</Button>
				</View>
			</ScrollView>
		</SafeAreaView>
	);
};

export default RecreatePasswordScreen;

const styles = StyleSheet.create({
	root: {
		flex: 1,
		backgroundColor: "#fff",
		paddingHorizontal: "5%",
	},

	header: {
		fontWeight: "600",
		fontSize: 32,
		marginVertical: 20,
		paddingHorizontal: 24,
	},
	inputs: {
		width: "100%",
		zIndex: 0,
		borderWidth: 1,
	},
	input: {
		alignSelf: "center",
		width: "100%",
		borderWidth: 1,
	},
	btn: {
		marginTop: 30,
		borderRadius: 25,

		height: 50,

		alignSelf: "center",
	},
	btnText: {
		color: "#fff",
		fontSize: 15,
		lineHeight: 30,
		width: "90%",
	},
	text: {
		letterSpacing: 0.25,
		color: "#999999",
		lineHeight: 20,
		fontWeight: "400",
		fontSize: 15,
		marginBottom: 30,
		paddingHorizontal: 24,
	},
});
